"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var UiStateController_1 = require("../../../../../shared/UiStateController");
var routes_1 = require("../../../../shared/includes/routes");
var BonusFreeSpinRangesList_1 = require("./component/BonusFreeSpinRangesList");
var BonusFreeSpinRangeGameSetsList_1 = require("./component/BonusFreeSpinRangeGameSetsList");
var BonusFreeSpinRangeGameSetsEditor_1 = require("./component/BonusFreeSpinRangeGameSetsEditor");
var BonusFreeSpinRangesListEditor_1 = require("./component/BonusFreeSpinRangesListEditor");
var PBonusFreeSpinRangesList = /** @class */ (function (_super) {
    __extends(PBonusFreeSpinRangesList, _super);
    function PBonusFreeSpinRangesList(props) {
        return _super.call(this, props) || this;
    }
    PBonusFreeSpinRangesList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_AB = this.props.listBrands.Subscribe("*", function (id, data) {
            _this.setState({ avail_brands: data.data });
        });
        this.SID_AC = this.props.listAppCurrency.Subscribe("*", function (id, data) {
            _this.setState({ avail_currency: data.data });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                brands_list: data.brands_list,
                all_brands: data.all_brands,
                page_size: data.tablePageSize,
                all_currency: data.all_currency,
                currency_id: data.currency_id
            });
        });
        this.setState({
            edit_mode: "LIST",
            rootRecord: null,
            record: null,
            page_num: 1,
            page_size: this.props.state.getTablePageSize(),
            brands_list: this.props.state.getBrandsList(),
            all_brands: this.props.state.getIsAllBrands(),
            avail_brands: [],
            currency_id: this.props.state.getCurrencyId(),
            all_currency: this.props.state.getIsAllCurrency(),
        }, function () {
            _this.props.listBrands.LoadData();
            _this.props.listAppCurrency.LoadData();
        });
    };
    PBonusFreeSpinRangesList.prototype.componentWillUnmount = function () {
        this.props.listBrands.UnSubscribe(this.SID_AB);
        this.props.listAppCurrency.UnSubscribe(this.SID_AC);
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    PBonusFreeSpinRangesList.prototype.onNewClick = function () {
        this.setState({ edit_mode: "NEW", rootRecord: null });
    };
    PBonusFreeSpinRangesList.prototype.onEditClick = function (item) {
        this.setState({ edit_mode: "EDIT", rootRecord: item });
    };
    PBonusFreeSpinRangesList.prototype.onNewRangeClick = function () {
        this.setState({ edit_mode: "FS-RANGE-NEW", record: null });
    };
    PBonusFreeSpinRangesList.prototype.onEditRangeClick = function (item) {
        this.setState({ edit_mode: "FS-RANGE-EDIT", record: item });
    };
    PBonusFreeSpinRangesList.prototype.onConfigClick = function (item) {
        this.setState({ edit_mode: "FS-RANGES-LIST", rootRecord: item });
    };
    PBonusFreeSpinRangesList.prototype.onGoBackClick = function () {
        this.setState({ edit_mode: "LIST", rootRecord: null });
    };
    PBonusFreeSpinRangesList.prototype.onGoBackChildListClick = function () {
        this.setState({ edit_mode: "FS-RANGES-LIST", record: null });
    };
    PBonusFreeSpinRangesList.prototype.onPageConfigChange = function (PageNum, PageSize) {
        var _this = this;
        this.setState({ page_num: PageNum }, function () {
            _this.props.state.setTablePageSize(PageSize, true);
        });
    };
    PBonusFreeSpinRangesList.prototype.onBrandFilterChanged = function (allBrands, BrandId, Action) {
        if (Action === "checkbox") {
            this.props.state.setAllBrands(allBrands, true);
        }
        if (Action === "add") {
            this.props.state.addBrand(BrandId, true);
        }
        if (Action === "remove") {
            this.props.state.delBrand(BrandId, true);
        }
    };
    PBonusFreeSpinRangesList.prototype.onCurrencyFilterChanged = function (allCurrency, CurrencyId) {
        this.props.state.setAllCurrency(allCurrency, true);
        this.props.state.setCurrencyId(CurrencyId, true);
    };
    PBonusFreeSpinRangesList.prototype.getRenderObject = function () {
        if (this.state.edit_mode === "NEW") {
            return (React.createElement(BonusFreeSpinRangesListEditor_1.default, { data: this.props.data, state: this.props.state, record: null, onGoBack: this.onGoBackClick.bind(this), listBrands: this.props.listBrands }));
        }
        if (this.state.edit_mode === "EDIT") {
            return (React.createElement(BonusFreeSpinRangesListEditor_1.default, { data: this.props.data, state: this.props.state, record: this.state.rootRecord, onGoBack: this.onGoBackClick.bind(this), listBrands: this.props.listBrands }));
        }
        if (this.state.edit_mode === "LIST") {
            return (React.createElement(BonusFreeSpinRangesList_1.default, { data: this.props.data, state: this.props.state, onNewClick: this.onNewClick.bind(this), onEditClick: this.onEditClick.bind(this), onPageConfigChanged: this.onPageConfigChange.bind(this), pageNum: this.state.page_num, pageSize: this.state.page_size, brandsList: this.state.brands_list, allBrands: this.state.all_brands, availBrands: this.state.avail_brands, onBrandFilterChanged: this.onBrandFilterChanged.bind(this), onConfigClick: this.onConfigClick.bind(this), dlgSelectKeyVal: this.props.dlgSelectKeyVal, avail_currency: this.state.avail_currency }));
        }
        if (this.state.edit_mode === "FS-RANGES-LIST") {
            return (React.createElement(BonusFreeSpinRangeGameSetsList_1.default, { data: this.props.dataGameSets, state: this.props.state, onNewClick: this.onNewRangeClick.bind(this), onEditClick: this.onEditRangeClick.bind(this), allCurrency: this.state.all_currency, availCurrency: this.state.avail_currency, currencyId: this.state.currency_id, onCurrencyFilterChanged: this.onCurrencyFilterChanged.bind(this), onGoBackClick: this.onGoBackClick.bind(this), record: this.state.rootRecord }));
        }
        if (this.state.edit_mode === "FS-RANGE-NEW") {
            return (React.createElement(BonusFreeSpinRangeGameSetsEditor_1.default, { data: this.props.dataGameSets, state: this.props.state, record: null, onGoBack: this.onGoBackChildListClick.bind(this), listAppCurrency: this.props.listAppCurrency, listGameSet: this.props.listGameSet, rootRecord: this.state.rootRecord }));
        }
        if (this.state.edit_mode === "FS-RANGE-EDIT") {
            return (React.createElement(BonusFreeSpinRangeGameSetsEditor_1.default, { data: this.props.dataGameSets, state: this.props.state, record: this.state.record, onGoBack: this.onGoBackChildListClick.bind(this), listAppCurrency: this.props.listAppCurrency, listGameSet: this.props.listGameSet, rootRecord: this.state.rootRecord }));
        }
        throw "No available render for active edit mode -> " + this.state.edit_mode;
    };
    PBonusFreeSpinRangesList.prototype.render = function () {
        return this.getRenderObject();
    };
    PBonusFreeSpinRangesList.getPageDescription = function (state) {
        return {
            icon: "ruler-combined",
            iconKind: "normal",
            itemId: "item-" + routes_1.routes.page_gift_freespin_ranges + "-id",
            itemTitle: "Диапазоны ФС",
            route: routes_1.routes.page_gift_freespin_ranges,
            docType: UiStateController_1.UIDocumentType.udtRegularPage
        };
    };
    return PBonusFreeSpinRangesList;
}(React.Component));
exports.default = PBonusFreeSpinRangesList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_fsranges/ui/PBonusFreeSpinRangesList.tsx
// module id = 2491
// module chunks = 0